import { render } from "./LotRack.vue?vue&type=template&id=3f974f18"
import script from "./LotRack.vue?vue&type=script&lang=js"
export * from "./LotRack.vue?vue&type=script&lang=js"
script.render = render

export default script